import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/vuex/store";
import "@/api/scoket";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/font/iconfont.css";
import "animate.css";
import "@/assets/style/iconfont.css";

import "@/assets/style/success.scss";
import money from "@/components/common/money.vue";
import integral from "@/components/common/integral.vue";
import boxicon from "@/components/common/boxicon.vue";
import handleback from "@/components/common/back.vue";
import plusreduce from "@/components/common/plusreduce.vue";
import illustrate from "@/components/illustrate.vue";
// import vueSeamlessScroll from "vue-seamless-scroll";
import { socket } from "socket.io";
import VueAgile from "vue-agile";
import Video from "video.js";
import "video.js/dist/video-js.css";
import toastRegistry from "./views/toast/index";
import AudioPlugin from "../src/utils/audioPlugin";
// 复制插件
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true; // add this line
Vue.prototype.$video = Video;
// Vue.use(vueSeamlessScroll);

Vue.use(ElementUI);
Vue.prototype.$socket = socket;
Vue.component("money", money);
Vue.component("integral", integral);
Vue.component("handleback", handleback);
Vue.component("plusreduce", plusreduce);
Vue.component("boxicon", boxicon);
Vue.component("illustrate", illustrate);
Vue.config.productionTip = false;
Vue.use(VueAgile);
Vue.use(toastRegistry);
Vue.use(AudioPlugin);
Vue.use(VueClipboard);
import Router from "vue-router";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.filter("fullPath", (path) => {
  if (typeof path === "string" && path.trim()) {
    const baseUrl = "https://allincs2.com";
    // const baseUrl = 'http://38.12.33.187:8080';
    // 检查 path 是否以 http 或者 https 开头
    if (/^(http|https):\/\//i.test(path)) {
      return path.trim();
    } else {
      return baseUrl + path.trim();
    }
  }
  return ""; // 返回空字符串或默认值
});
Vue.prototype.$getFullPath = function (path) {
  // debugger;
  if (typeof path === "string" && path.trim()) {
    const baseUrl = "https://images.allincs2.com";
    // const baseUrl = 'http://38.12.33.187:8080';
    // 检查 path 是否以 http 或者 https 开头
    if (path.includes("img.zbt.com")) {
      return path;
    }
    if (/^(http|https):\/\//i.test(path)) {
      const index = path.indexOf("profile/");
      // 提取 profile/ 及之后的部分
      const trimmedPath = path.substring(index + "profile/".length).trim();
      return baseUrl + "/" + trimmedPath;
    } else {
      // 去掉可能存在的 profile 部分
      let trimmedPath = path.replace(/profile\//i, "").trim();
      return baseUrl + trimmedPath;
    }
  }
  return ""; // 返回空字符串或默认值
};
Vue.filter('formatNumber', function (value) {
  if (value >= 1000 && value < 10000) {
    return (value / 1000).toFixed(1) + 'K';
  } else if (value >= 10000) {
    return (value / 10000).toFixed(1) + 'W';
  } else {
    return value.toString();
  }
});
new Vue({
  router,
  store,
  beforeCreate() {
    // Vue.prototype.$ws=ws
    Vue.prototype.$bus = this;
  },
  render: (h) => h(App),
}).$mount("#app");
